import Logger from 'src/util/Logger';
import { isCollectionType, isQuestionType, isCommentType, isVoteType } from 'src/util/utils'
import { popinApiV2 } from 'src/api/api';

const collectionApi = {

  get: ({ id = '', query = '' }) => {
    let url = `/collections`
    if (id) url += `/${id}/details`
    if (query) url += `${query}`
    return popinApiV2.get(url)
      .catch(error => {
        // This will be handled in the saga
        // eslint-disable-next-line
        throw { collectionsError: error };
      })
  },

  getResponses: (id) => {
    return popinApiV2.get(`/collections/${id}/responses`);
  },

  getResult: (id) => {
    return popinApiV2.get(`/collections/${id}/result`);
  },

  delete: (id) => {
    return Promise.resolve().then(() => {
      return popinApiV2.del(`/collections/${id}`);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  getAllByType: (collectionType) => {
    return Promise.resolve().then(() => {
      if (!collectionType) {
        Logger.info('reject getAllByType()');
        throw Error('Must pass a collection type');
      }
      return popinApiV2.get(`/collections?type=${collectionType}`);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  create: (collection) => {
    return Promise.resolve().then(() => {
      if (!isCollectionType(collection)) {
        Logger.info('reject create()');
        throw Error('Must pass a collection');
      }
      return popinApiV2.post(`/collections`, collection);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  update: (collection) => {
    return Promise.resolve().then(() => {
      if (!isCollectionType(collection) || !collection.id) {
        Logger.info('reject update()');
        throw Error('Must pass existing collection with an id');
      }
      return popinApiV2.put(`/collections/${collection.id}`, collection);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  getQuestionsByCollectionId: (collectionId) => {
    console.log('getQuestionsByCollectionId');
    return Promise.resolve().then(() => {
      if (!collectionId) {
        Logger.info('reject getQuestionsByCollectionId()');
        throw Error('Must pass a collection id');
      }
      return popinApiV2.get(`/collections/${collectionId}/questions`);
    }).catch(error => {
      // This will be handled in the saga
      console.log(error);
      return { collectionsError: error };
    })
  },

  updateQuestion: (question) => {
    return Promise.resolve().then(() => {
      if (!isQuestionType(question)) {
        Logger.info('reject update()');
        throw Error('Must pass existing question');
      }
      return popinApiV2.put(`/questions/${question.id}`, question);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  createChildren: (parentCollectionId, collections) => {
    return Promise.resolve().then(() => {
      for (const collection of collections) {
        if (!isCollectionType(collection)) {
          Logger.info('reject createChildren()');
          throw Error('Must pass an array of collections');
        }
      }
      return popinApiV2.post(`/collections/${parentCollectionId}/children`, collections);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  createQuestions: (parentCollectionId, questions) => {
    return Promise.resolve().then(() => {
      for (const question of questions) {
        if (!isQuestionType(question)) {
          Logger.info('reject createQuestions()');
          throw Error('Must pass an array of questions');
        }
      }
      return popinApiV2.post(`/collections/${parentCollectionId}/questions`, questions);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  deleteQuestion: (questionId) => {
    return Promise.resolve().then(() => {
      if (!questionId) {
        Logger.info('reject deleteQuestion()');
        throw Error('Must pass a questionId');
      }
      return popinApiV2.del(`/questions/${questionId}`);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  deleteQuestions: (parentCollectionId) => {
    return Promise.resolve().then(() => {
      if (!parentCollectionId) {
        Logger.info('reject deleteQuestions()');
        throw Error('Must pass a parentCollectionId');
      }
      return popinApiV2.del(`/collections/${parentCollectionId}/questions`);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  vote: (vote) => {
    return Promise.resolve().then(() => {
      if (!isVoteType(vote)) {
        Logger.info('reject create()');
        throw Error('Must pass a vote');
      }
      return popinApiV2.post(`/vote`, vote);
    }).catch(error => {
      // This will be handled in the saga
      return { voteError: error };
    })
  },

  getComments: (collectionId) => {
    return Promise.resolve().then(() => {
      return popinApiV2.get(`/collections/${collectionId}/comments`);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

  addComment: (collectionId, comment, parentId) => {
    return Promise.resolve().then(() => {
      if (!isCommentType(comment)) {
        Logger.info('reject addComment()');
        throw Error('Must pass a comment');
      }
      if (parentId) {
        comment.parent_id = parentId;
      }
      return popinApiV2.post(`/collections/${collectionId}/comments`, comment);
    }).catch(error => {
      // This will be handled in the saga
      return { collectionsError: error };
    })
  },

}

export default collectionApi
